import React from 'react';
import {Row, Col, Modal, ModalHeader, ModalBody} from 'reactstrap';

import CodeReview from './CodeReviewComponent'

export default function CodeReviewModel(props)
{
	if(props.submission === null)
	{
		return null;
	}

	return (
		<Modal isOpen={props.isOpen} toggle={props.toggle} style={{minWidth:'95vw'}}>
			<ModalHeader toggle={props.toggle}>
				CodeReview
			</ModalHeader>
			<ModalBody>
				{
					props.submission.requested &&
					<Row>
						<Col>
							<span>{props.submission.avatar} pita:</span>
							<pre>
								{props.submission.requestText}
							</pre>
						</Col>
					</Row>
				}
				<Row>
					<Col>
						<CodeReview  submission={props.submission}
							onSetCodeReview={props.onSetCodeReview}
							toggle={props.toggle}
							onSetCodeReviewModalDirty={props.onSetCodeReviewModalDirty}/>
					</Col>
				</Row>

			</ModalBody>
		</Modal>
	);
}

